import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';

import { UploadDailyReportPhotoField } from 'modules/components/layer04';

export type SaveDailyReportPhotoFormProps = {
  id: string;
  dailyReportId: string;
  handleClose: () => void;
};

export const FC = (props: SaveDailyReportPhotoFormProps) => {

  const form = ds.useFormState(props.dailyReportId);
  const handleSubmit = async () => {
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit();
      }}
      cancelButtonText='Cancel'
      ignoreCancel={true}
      successButtonText='Done'
      isLoading={form.formState.isUploading}
    >
      <UploadDailyReportPhotoField.FC
        fieldName='apiFileQueue'
        form={form}
        uploadCountFieldName='uploadCount'
        uploadInProgressFieldName='isUploading'
      />
    </FormBaseLayout.FC>

  );
};
